import * as z from "zod/v4";

export const deleteContextualIntegration = {
  name: "deleteContextualIntegration" as const,
  input: z.object({ integrationId: z.string() }),
  output: z.object({ success: z.boolean() }),
};

export const bulkDeleteContextualIntegrations = {
  name: "bulkDeleteContextualIntegrations" as const,
  input: z.object({ integrationIds: z.array(z.string()) }),
  output: z.object({ deletedIds: z.array(z.string()) }),
};
